import { render, staticRenderFns } from "./LayoutForm.vue?vue&type=template&id=2438734a"
import script from "./LayoutForm.vue?vue&type=script&lang=js"
export * from "./LayoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports